import { Typography } from '@mui/material';
import type React from 'react';

import { useStyles } from './SubmitErrorMessage.styles';

interface SubmitErrorMessageProps {
  children?: React.ReactNode;
  testId?: string;
}

const SubmitErrorMessage = ({ children, testId }: SubmitErrorMessageProps) => {
  const { classes } = useStyles();
  if (!children) return null;

  return (
    <Typography
      variant='bodyMd'
      color='semantic.text.error'
      className={classes.errorText}
      role='alert'
      data-testid={testId}
    >
      {children}
    </Typography>
  );
};

export default SubmitErrorMessage;
